import { Injectable } from '@angular/core';
import { get, set, del } from 'idb-keyval';
import { StoredCredential } from '../passkey.model.model';

const DB_KEY = 'axon.passkey.v1';

@Injectable({ providedIn: 'root' })
export class PasskeyStoreService {
  /** persist */
  async save(cred: StoredCredential): Promise<void> {
    await set(DB_KEY, cred);
  }

  /** load (null if none) */
  async load(): Promise<StoredCredential | null> {
    return (await get(DB_KEY)) ?? null;
  }

  /** delete */
  async clear(): Promise<void> {
    await del(DB_KEY);
  }
}
